import styled from "@emotion/styled";
import { LoadingSpinner } from "src/atoms/LoadingSpinner";

// NOTE: 'styled' is used to workaround a known issue of passing props to Styled Components
// Source: https://github.com/styled-components/styled-components/issues/1198#issuecomment-447885637
const StyledLoading = styled.div<{ styled: { loading: boolean } }>`
  background: white;
  opacity: ${(props) => (props.styled.loading ? "0.7" : 0)};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  z-index: 1;
`;

const StyledLoadingSpinner = styled(LoadingSpinner)`
  height: auto;
  top: 70%;
`;

export default function LoadingDimmer({
  loading,
  ...props
}: {
  loading: boolean;
}): JSX.Element | null {
  if (loading === false) {
    return null;
  }
  return (
    <StyledLoading styled={{ loading }} {...props}>
      {loading && <StyledLoadingSpinner />}
    </StyledLoading>
  );
}
